export const colors = {
  Black: '#000000',
  Black100: '#373737',
  Blue: '#363BC4',
  Blue02: '#0F0F36',
  Blue02Opacity: '#0F0F3633',
  BlueGreenGradient: 'linear-gradient(107.22deg, #363BC4 29.9%, #00FF9B 123.46%)',
  Green: '#00FF9B',
  Green02: '#00D698',
  Grey: '#9C9C9C',
  Grey02: '#EFF1F4',
  Grey03: '#E1E1E1',
  Grey04: '#CAD3E0',
  White: '#FFFFFF',
  Black900: '#0A0D14',
  Green500: '#39B719',
  Grey100: '#F6F8FA',
  Grey200: '#E2E4E9',
  Grey300: '#CDD0D5',
  Grey400: '#868C98',
  Grey500: '#525866',
  Blue700: '#363BC4',
  Blue900: '#0F0F36',
  BlueDark900: '#2F3580',
  Blue900Opacity: '#0F0F3633',
  Red600: '#DD1818',
  Orange600: '#F28602',
  Soft200: '#E2E4E9',
};
